export default "__VITE_ASSET__CNFkx$e8__"